import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PAGING_HEADERS } from '@app/app.constants';
import { ApiHeaders } from '@core/core.types';
import { HttpUtils } from '@core/utils/http-utils';
import { environment } from '@root/environments/environment';
import { map, Observable } from 'rxjs';
import {
  ResultImport,
  ResultImportRequestData,
  ResultImportSaga,
} from '../types/result.types';

@Injectable({
  providedIn: 'root',
})
export class ResultsImportService {
  private http = inject(HttpClient);

  private readonly apiUrl = `${environment.apiUrl}/digital-reports`;

  public importResults(
    data: ResultImportRequestData
  ): Observable<{ id: string }> {
    return this.http.post<{ id: string }>(
      `${this.apiUrl}/raw-data/import`,
      data
    );
  }

  public checkSagaState(id: string): Observable<ResultImportSaga> {
    return this.http.get<ResultImportSaga>(
      `${this.apiUrl}/imports/${id}/status`
    );
  }

  public getImport(importId: string) {
    return this.http.get<ResultImport>(`${this.apiUrl}/imports/${importId}`);
  }

  public listImports(filters: HttpParams, headers: ApiHeaders) {
    return this.http
      .get<ResultImport[]>(`${this.apiUrl}/imports`, {
        observe: 'response',
        params: filters,
        headers: HttpUtils.buildHttpHeaders(headers),
      })
      .pipe(
        map((response) => ({
          items: response.body,
          continuationToken: response.headers.get(
            PAGING_HEADERS.continuationToken
          ),
          totalCount: parseInt(
            response.headers.get(PAGING_HEADERS.totalCount),
            10
          ),
        }))
      );
  }
}
